// extracted by mini-css-extract-plugin
module.exports = {"page":"ErrorPage-page-3GptQ Page-page-jTeFt","version":"ErrorPage-version-3txe6"};